import md5 from 'md5';

export default {
  hash(input) {
    return md5(input);
  }
};
